import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Routes } from 'Utils';
import { RouteComponentProps, withRouter } from 'react-router';

interface HomeProps extends RouteComponentProps {
	history: any;
}
const useStyles = makeStyles({
	root: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		margin: '10rem auto',
		maxWidth: 345,
	},
	card: {
		maxWidth: 345,
	},
	media: {
		height: 140,
	},
});

const NotFound = ({ history }: HomeProps) => {
	const classes = useStyles();
	const goBack = () => {
		history.push(Routes.Login);
	};
	return (
		<Fragment>
			<div className={classes.root}>
				<h2 className="text-danger text-center display-2">Oops 🙊 </h2>
				<h4 className="text-secondary text-center">Looks like you are lost!</h4>
				<Button size="small" color="primary" onClick={goBack}>
					Go back
				</Button>
			</div>
		</Fragment>
	);
};

export default withRouter(NotFound);
